import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './Styles/index.css'
import App from '@/App.jsx'
import reportWebVitals from '@utils/reportWebVitals'
import { sanitizePathParam } from './utils/security'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

reportWebVitals();

// Handle query param 'p' that rewrites to internal path. We sanitize the value
// to avoid open-redirects or path injection. This logic was previously in index.html
// but we keep it client-side inside our sanitized helper.
(() => {
  try {
    const raw = new URLSearchParams(window.location.search).get('p');
    const p = sanitizePathParam(raw);
    if (p) {
      const newPath = `/blog/${p}${window.location.hash || ''}`;
      window.history.replaceState(null, '', newPath);
    }
  } catch (e) {
    // don't break the app on parse errors
    console.warn('Failed to sanitize redirect query param', e);
  }
})();
